import React, { useMemo, useState, useRef } from 'react';
import { FormGroup, Label, Input, Button } from 'reactstrap';
import { inputId, inputName } from '../../../helper/form';
import FieldError from '../../../helper/FieldError';

import ComplianceActivityEvidenceChild from './child';

const ComplianceActivityEvidenceItem = (props) => {
  const {
    index,
    evidence,
    configuration: {
      formName,
    },
    callbacks: {
      onChangeEvidences: callbackOnChangeEvidences
    }
  } = props;

  const [isFileLoaded, setIsFileLoaded] = useState(false);
  const fileInputRef = useRef(null);

  const onChangeActivityEvidence = (event, key) => {
    let _evidence = { ...evidence }
    let value = event.target.value;

    if(event.target.type == 'checkbox'){
      value = event.target.checked;
    }

    if(event.target.type == 'file'){
      value = event.target.files[0];
      setIsFileLoaded(!!value);
    }

      _evidence[key] = value;

    if(_.isFunction(callbackOnChangeEvidences)){
      callbackOnChangeEvidences(index, _evidence)
    }
  }

  const onDestroyEvidence = e => {
    swalWithBootstrap.fire({
      title: 'Eliminar evidencia',
      html: '<p>¿Estás seguro de eliminar el documento principal?</p>',
    }).then( result => {
      if(result.isConfirmed){
        onChangeActivityEvidence({
          target: { value: true },
        }, '_destroy')
      }
    })
  }

  const onChangeChildren = (childIndex, child) => {
    let _children = [...(evidence.children || [])];
    _children[childIndex] = child;

    let _evidence = { ...evidence, children: _children };

    if(_.isFunction(callbackOnChangeEvidences)){
      callbackOnChangeEvidences(index, _evidence)
    }
  }

  const addNewChild = () => {
    let _evidence = { ...evidence };

    let childAttributes = {
      id: "",
      name: "",
      template: null,
      is_recurrent: true,
      _destroy: false,
    }

    _evidence.children.push(childAttributes);

    if(_.isFunction(callbackOnChangeEvidences)){
      callbackOnChangeEvidences(index, _evidence)
    }
  }

  const onDestroyChild = (childIndex) => {
    swalWithBootstrap.fire({
      title: 'Eliminar evidencia',
      html: '<p>¿Estás seguro de eliminar la evidencia complementaria?</p>',
    }).then( result => {
      if(result.isConfirmed){
        let _children = [...(evidence.children || [])];
        _children[childIndex] = { ..._children[childIndex], _destroy: true };

        let _evidence = { ...evidence, children: _children };

        if(_.isFunction(callbackOnChangeEvidences)){
          callbackOnChangeEvidences(index, _evidence)
        }
      }
    })
  }

  const availableChildren = useMemo(() => {
    return _.filter(evidence?.children || [], (child) => {
      return !child._destroy
    })
  }, [evidence])

  return (
    <div className="nested-fields">
      <div className="card hover-card">
        <div className="card-body">
          <div className="row justify-content-between">
            <div className="col-md-6">
              <FormGroup>
                <Label for={ inputId(formName, 'name') } className='required'>
                  Documento Principal
                </Label>
              </FormGroup>
            </div>
            <div className="col-md-6">
              <div className="d-flex justify-content-end">
                <div className="custom-switch mr-5">
                  <FieldError errors={ evidence?.errors?.is_recurrent || [] }>
                    <Input
                      type='checkbox'
                      className='custom-control-input'
                      id={ inputId(formName, 'is_recurrent') }
                      name={ inputName(formName, 'is_recurrent') }
                      checked={ evidence?.is_recurrent || false }
                      invalid={ _.has(evidence?.errors, 'is_recurrent') }
                      onChange={ e => onChangeActivityEvidence(e, 'is_recurrent') }
                    />
                    <Label
                      className='custom-control-label'
                      for={ inputId(formName, 'is_recurrent') }
                    >
                      { I18n.t('activerecord.attributes.compliance/evidence.is_recurrent') }
                    </Label>
                  </FieldError>
                </div>
                <div className="text-end">
                  <Button
                    color='danger'
                    size='sm'
                    onClick={ e => onDestroyEvidence(e) }
                    outline
                    title='Eliminar evidencia principal'
                  >
                    <i className="fas fa-trash"></i>
                  </Button>
                </div>
              </div>
            </div>
            <div className="col-md-10">
              <FormGroup>
                <FieldError errors={ evidence?.errors?.name || [] }>
                  <Input
                    type='text'
                    id={ inputId(formName, 'name') }
                    name={ inputName(formName, 'name') }
                    placeholder="Nombre de Documento"
                    invalid={ _.has(evidence?.errors, 'name') }
                    value={ evidence?.name || '' }
                    onChange={ e => onChangeActivityEvidence(e, 'name') }
                  />
                </FieldError>
              </FormGroup>
            </div>
            <div className="col-md-2">
              <Input
                innerRef={fileInputRef}
                type='file'
                id={ inputId(formName, 'template') }
                name={ inputName(formName, 'template') }
                className='d-none'
                onChange={ e => onChangeActivityEvidence(e, 'template') }
              />
              <span className="mx-2">o</span>
              <Label
                for={ inputId(formName, 'template') }
                className={`btn btn-sm text-end ${isFileLoaded ? 'btn-info' : 'btn-outline-info'}`}
                style={{ cursor: 'pointer' }}
              >
                {isFileLoaded ? (
                  <>
                    <i className="fas fa-check mr-2"></i>
                    cargado
                  </>
                ) : (
                  <>
                    <i className="fas fa-upload mr-2"></i>
                    { I18n.t('actions.upload_template') }
                  </>
                )}
              </Label>
            </div>
          </div>

          <div id='children'>
            {
              _.map(availableChildren, (child, childIndex) => {
                return (
                  <ComplianceActivityEvidenceChild
                    key={ `evidenceChild-${ index }-${ childIndex }` }
                    index={ childIndex }
                    parentIndex={ index }
                    child={ child }
                    configuration={{
                      formName: `${ formName }[children_attributes][${ childIndex }]`
                    }}
                    callbacks={{
                      onChangeChildren: onChangeChildren,
                      onDestroyChild: onDestroyChild
                    }}
                  />
                )
              })
            }
            <div className="links mt-3">
              <Button
                outline
                color="primary"
                size="sm"
                onClick={ e => addNewChild(e) }
              >
                <i className="fa fa-plus mr-2"></i>
                { I18n.t("actions.add") } { I18n.t('activerecord.models.compliance/evidence.other').toLowerCase() }
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ComplianceActivityEvidenceItem;
